module.exports = __webpack_public_path__ + "img/捷成维科.png";